import type { ReactNode } from 'react';

export type MetricKind = 'ok' | 'warn' | 'danger' | 'neutral';

type HeroStatProps = {
  label: string;
  value: ReactNode;
  unit?: string;
  chip?: { kind: 'ok' | 'warn' | 'danger'; text: string };
};

export function HeroStat({ label, value, unit, chip }: HeroStatProps) {
  return (
    <div className="card">
      <div className="row between" style={{ marginBottom: 8 }}>
        <span className="label">{label}</span>
        {chip && (
          <span className={`chip ${chip.kind}`}>
            <span className="dot" /> {chip.text}
          </span>
        )}
      </div>
      <div className="num-lg">
        {value}
        {unit && <span className="unit">{unit}</span>}
      </div>
    </div>
  );
}

type SnapMetricProps = {
  label: string;
  value: ReactNode;
  unit?: string;
  kind?: MetricKind;
};

export function SnapMetric({ label, value, unit, kind = 'neutral' }: SnapMetricProps) {
  const color =
    kind === 'danger'
      ? 'var(--danger)'
      : kind === 'warn'
        ? 'var(--warn)'
        : kind === 'ok'
          ? 'var(--ok)'
          : 'var(--ink)';
  return (
    <div>
      <div className="stat-label">{label}</div>
      <div className="num-md" style={{ color, marginTop: 4 }}>
        {value}
        {unit && <span className="unit">{unit}</span>}
      </div>
    </div>
  );
}

type StatProps = {
  label: string;
  value: ReactNode;
  unit?: string;
  delta?: string;
  deltaKind?: 'up' | 'down';
};

export function Stat({ label, value, unit, delta, deltaKind }: StatProps) {
  return (
    <div>
      <div className="stat-label">{label}</div>
      <div className="num-lg">
        {value}
        {unit && <span className="unit">{unit}</span>}
      </div>
      {delta && (
        <div className={`stat-delta ${deltaKind ?? ''}`} style={{ marginTop: 6 }}>
          {delta}
        </div>
      )}
    </div>
  );
}
